import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, skipWhile, switchMap, take, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';
import { WorkerService } from 'src/app/core/services/worker.service';
import { InventarService } from 'src/app/core/services/inventar.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { FilialService } from 'src/app/core/services/filial.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-workers',
  templateUrl: './workers.component.html',
})
export class WorkersComponent implements OnInit {
  users: any;
  companyId: string;
  company: any;
  currentUser: any;
  toggleChangePassword = false;
  toggleInventars = false;
  selectedInventarId = '';
  selectedFilialId = '';
  inventars: any;
  filials: any;

  searchControlName = new FormControl();
  searchControlEmail = new FormControl();
  formCtrlSub: Subscription;
  formCtrlSub2: Subscription;

  searchName: string;
  searchEmail: string;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private authService: AuthService,
    private toastr: ToastrService,
    private workerService: WorkerService,
    private inventarService: InventarService,
    private filialService: FilialService
  ) {}

  ngOnInit(): void {
    this.route.parent.data.subscribe((res) => {
      this.company = res.company;
      this.companyId = res.company?.id;
      this.breadcrumbService.set('@companyName', this.company?.name);
    });

    this.authService.LoggedinUser.pipe(
      skipWhile((user) => user === null),
      take(1)
    ).subscribe((user) => {
      this.currentUser = user;
      if(this.currentUser.role.name === 'user' || this.currentUser.role.name === 'filialAdmin') {
        this.companyId = this.currentUser.companyId;
        this.company = this.currentUser.company;
      }
    });

    this.formCtrlSub = this.searchControlName.valueChanges
        .pipe(
          debounceTime(800),
          distinctUntilChanged(),
          tap((value) => {
          // this.isLoading = true;
           this.searchName = value;
          }),
          switchMap((changedValue) => this.getUsers())
        )
        .subscribe((res) => {
          this.users = res;
          this.checkStatus(this.users);
          //this.isLoading = false;
        });

        this.formCtrlSub2 = this.searchControlEmail.valueChanges
        .pipe(
          debounceTime(800),
          distinctUntilChanged(),
          tap((value) => {
          // this.isLoading = true;
           this.searchEmail = value;
          }),
          switchMap((changedValue) => this.getUsers())
        )
        .subscribe((res) => {
          this.users = res;
          this.checkStatus(this.users);
          //this.isLoading = false;
        });

    this.loadUsers();
    this.loadFilials();
  }

  getUsers(): Observable<any> {
    return this.userService.getCompanyWorkers(this.companyId, this.searchName, this.searchEmail);
  }

  loadUsers() {
    this.getUsers().subscribe(
      (res) => {
        this.users = res;
        this.checkStatus(this.users);
        console.log('hdshadhsa')
      },
      (err) => {}
    );
  }

  loadFilials() {
    this.filialService.getCompanyFilials(this.companyId, undefined).subscribe(
      (res) => {
        this.filials = res;
      },
      (err) => {}
    );
  }

  loadInventars() {
    this.inventarService.getAllFilialInventars(this.selectedFilialId).subscribe(
      (res) => {
        this.inventars = res;
      },
      (err) => {}
    );
  }

  checkStatus(users) {
    users.forEach((user) => {
      const tzoffset = -120 * 60000; // offset in milliseconds
      const localISOTime = new Date(Date.now() - tzoffset)
        .toISOString()
        .slice(0, -1);

      const localOffset = new Date().getTimezoneOffset() * 60 * 1000;

      const serverTime = new Date(user.lastTimeOnline).getTime() + localOffset;

      const localTime = new Date(localISOTime).getTime();

      const difference = Math.abs(localTime - serverTime);

      const sec = difference / 1000;
      const min = difference / (1000 * 60);
      const hours = difference / (1000 * 60 * 60);
      const days = difference / (1000 * 60 * 60 * 24);
      const week = difference / (1000 * 60 * 60 * 24 * 7);
      const month = difference / (1000 * 60 * 60 * 24 * 30);
      const year = difference / (1000 * 60 * 60 * 24 * 365);

      // console.log("sekunde " + difference/1000)
      // console.log("minutes " + difference/(1000 * 60))
      // console.log("hours " + difference/(1000 * 60 * 60))
      // console.log("days: " + difference/(1000 * 60 * 60 * 24))
      // console.log("meseci:" + month)

      if (year > 1) {
        user.online = 'a year ago';
      } else if (year < 1 && month > 1) {
        const months = Math.round(month);
        months === 1
          ? (user.online = `${months} month ago`)
          : (user.online = `${months} months ago`);
      } else if (month < 1 && days > 1) {
        const day = Math.round(days);
        day === 1
          ? (user.online = `${day} day ago`)
          : (user.online = `${day} days ago`);
      } else if (days < 1 && hours > 1) {
        const hour = Math.round(hours);
        hour === 1
          ? (user.online = `${hour} hour ago`)
          : (user.online = `${hour} hours ago`);
        user.onlineColor = '#ef0909';
      } else if (hours < 1 && min > 6) {
        const minute = Math.round(min);
        user.online = `${minute} minutes ago`;
        user.onlineColor = '#e6a92b';
      } else {
        user.online = `online`;
        user.onlineColor = '#119e11';
      }
    });
  }

  selectedUser = null;
  toggleDeleteUser = false;
  showUser(user) {
    this.selectedUser = user;
  }

  onDeleteUser(user) {
    this.selectedUser = user;
    this.toggleDeleteUser = true;
  }

  deleteUser() {
    this.toggleDeleteUser = false;
    this.workerService.deleteCompanyWorker(this.companyId, this.selectedUser.id).subscribe(
      (res) => {
        this.loadUsers();
        this.selectedUser = null;
        this.toastr.success('Success.');
      },
      (err) => {}
    );
  }

  seeInventars(user) {
    this.selectedUser = user;

    this.workerService.getWorkerAssignedInventars(user.id).subscribe(
      (res) => {
        this.selectedUser.inventars = res;
        this.toggleInventars = true;
      },
      (err) => {}
    );
  }

  onCloseInventars() {
    this.toggleInventars = false;
    this.selectedUser = null;
    this.selectedInventarId = '';
    this.selectedFilialId = '';
  }

  assignWorkerToInventar() {
    if (!this.selectedInventarId) {
      return;
    }

    this.inventarService
      .assignWorkersToFilialInventar(
        this.selectedFilialId,
        this.selectedInventarId,
        [this.selectedUser.id]
      )
      .subscribe(
        (res) => {
          this.loadUsers();
          this.seeInventars(this.selectedUser)
          this.selectedInventarId = '';
          this.selectedFilialId = '';
          this.toastr.success('Success');
        },
        (err) => {}
      );
  }

  unassignWorker(inventar) {
    this.inventarService
      .removeWorkerFromFilialInventar(
        inventar.filialId,
        inventar.id,
        [this.selectedUser.id]
      )
      .subscribe(
        (res) => {
          this.loadUsers();
          this.seeInventars(this.selectedUser)
          this.selectedInventarId = '';
          this.selectedFilialId = '';
          this.toastr.success('Worker has been removed from inventar.');
        },
        (err) => {}
      );
  }
}
